import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import {BehaviorSubject, Observable} from 'rxjs';
import { map } from 'rxjs/operators';
import * as moment from 'moment';

import { DataFormatterService } from 'tis-data-formatter';

import { AppConfig } from '@root/app.config';
import { LONG_DATE_FORMATS } from '@core/locale.model';
import { User } from '@core/user.model';

@Injectable({
	providedIn: 'root'
})
export class LocaleService {

	currentLang$ = new BehaviorSubject(this.translate.currentLang);
	manuallyChangedLanguage: string = '';


	constructor(
		private readonly translate: TranslateService,
		private readonly dataFormatter: DataFormatterService,
		private readonly http: HttpClient,
		private readonly appConfig: AppConfig
	) {}

	private setLangData(language: string): void {
		this.translate.setDefaultLang(language);
		this.appConfig.setCurrentLanguage(language);
		this.currentLang$.next(this.translate.currentLang);
		moment.locale(language);

		const format = LONG_DATE_FORMATS[language];
		if (format) {
			moment.updateLocale(language, format);
		}
		this.dataFormatter.configuration({locale: language, offset: moment().utcOffset()});
	}

	public setLang(language: string, manualChange: boolean = false): Observable<string> {
		if (manualChange) {
			this.manuallyChangedLanguage = language;
		}
		return this.translate.use(language).pipe(
			map(() => {
				this.setLangData(language);
				return language;
			})
		);
	}

	public getLang(): string {
		return this.translate.currentLang ? this.translate.currentLang : this.appConfig.getDefaultLang();
	}

	public getAccountTimeZone(): Observable<string> {
		return this.http.get<User>(this.appConfig.api('me')).pipe(
			map((user: User) => user.timeZoneId)
		);
	}
}
